<template>
    <div class="home-pack" id="pack">
        <h2 class="home-pack__title">Découvrez votre pack</h2>
        <div class="home-pack-content">
            <img class="pack-illu" src="/images/fr_multigift/pack-illu.png" alt="">
            <div class="pack-item" v-for="(item, itemKey) in pack" :key="itemKey">
                <div class="item-banner">
                    <img :src="item.icon" :alt="item.alticon">
                    <span>{{ item.bannertext }}</span>
                </div>
                <h3 class="item-title">{{ item.title }}</h3>
                <p class="item-text">{{ item.text }}</p>
                <ul class="item-list">
                    <li v-for="(subitem, subitemKey) in item.list" :key="subitemKey">
                        <img src="/images/fr_multigift/list-check.svg" alt="">
                        {{ subitem }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="home-pack-carousel">
            <hooper ref="packcarousel" :infiniteScroll="true" :wheelControl="false">
                <slide v-for="(item, itemKey) in pack" :key="itemKey">
                    <div class="pack-item">
                        <div class="item-banner">
                            <img :src="item.icon" :alt="item.alticon">
                            <span>{{ item.bannertext }}</span>
                        </div>
                        <h3 class="item-title">{{ item.title }}</h3>
                        <p class="item-text">{{ item.text }}</p>
                        <ul class="item-list">
                            <li v-for="(subitem, subitemKey) in item.list" :key="subitemKey">
                                <img src="/images/fr_multigift/list-check.svg" alt="">
                                {{ subitem }}
                            </li>
                        </ul>
                    </div>
                </slide>
                <pagination slot="hooper-addons" mode="fraction"></pagination>
                <navigation slot="hooper-addons">
                    <template #hooper-prev>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                            <g fill="none" fill-rule="evenodd" stroke="#fff" transform="translate(1 1)">
                                <path fill="#fff" fill-rule="nonzero" stroke-width=".5"
                                      d="M17.7 14.2c.3-.3.8-.3 1 0 .4.3.4.8 0 1l-5.2 5.3h17.4c.4 0 .8.3.8.7 0 .4-.4.7-.8.7H13.5l5.3 5.3c.3.3.3.7 0 1-.3.3-.8.3-1 0l-6.6-6.5a.7.7 0 010-1l6.5-6.5z"/>
                                <circle cx="21" cy="21" r="21"/>
                            </g>
                        </svg>
                    </template>
                    <template #hooper-next>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                            <g fill="none" fill-rule="evenodd" stroke="#fff" transform="matrix(-1 0 0 1 43 1)">
                                <path fill="#fff" fill-rule="nonzero" stroke-width=".5"
                                      d="M17.7 14.2c.3-.3.8-.3 1 0 .4.3.4.8 0 1l-5.2 5.3h17.4c.4 0 .8.3.8.7 0 .4-.4.7-.8.7H13.5l5.3 5.3c.3.3.3.7 0 1-.3.3-.8.3-1 0l-6.6-6.5a.7.7 0 010-1l6.5-6.5z"/>
                                <circle cx="21" cy="21" r="21"/>
                            </g>
                        </svg>
                    </template>
                </navigation>
            </hooper>
        </div>
        <ScrollLink link="#services" styleType="inverted" arrow="blue">découvrez vos avantages</ScrollLink>
    </div>
</template>

<script>
import {Hooper, Slide, Pagination, Navigation} from 'hooper';
import ScrollLink from "../ScrollLink";

export default {
    name: "HomePack",
    components: {
        Hooper, Slide, Pagination, Navigation, ScrollLink
    },
    data() {
        return {
            pack: [
                {
                    icon: '/images/fr_multigift/pack1.svg', alticon: 'alticon',
                    bannertext: 'Accédez à un catalogue complet de cadeaux ',
                    title: 'Choisissez votre cadeau',
                    text: 'Le consommateur devrait toujours avoir le choix. C’est pourquoi, Testachats vous propose de choisir parmi un catalogue de cadeaux variés :',
                    list: [
                        'High-Tech',
                        'Beauté & Bien-être',
                        'Maroquinerie & bijoux',
                        'Brico & jardin',
                        'Petits électroménagers',
                        'Déco & art de la table',
                        'Cartes cadeaux',
                    ]
                },
                {
                    icon: '/images/fr_multigift/pack2.svg', alticon: '2€',
                    bannertext: 'Profitez de votre offre d\'essai à 2€/2 mois',
                    title: 'Vous bénéficiez de',
                    list: [
                        'Votre cadeau de bienvenue au choix',
                        'Vos magazines en version papier et/ou numérique  ',
                        'Une assistance juridique, fiscale et technique illimitée ',
                        '12 guides pratiques au choix ',
                    ]
                }
            ]
        }
    },
    methods: {
        slidePrev() {
            this.$refs.packcarousel.slidePrev();
        },
        slideNext() {
            this.$refs.packcarousel.slideNext();
        },
        updateCarousel(payload) {
            this.myCarouselData = payload.currentSlide;
        }
    }
}
</script>

<style scoped>

</style>
